import { render, staticRenderFns } from "./SubjectFinalStatusRequests.vue?vue&type=template&id=6334f70c&"
import script from "./SubjectFinalStatusRequests.vue?vue&type=script&lang=js&"
export * from "./SubjectFinalStatusRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports